import React from 'react';
import { AlertTriangle, ArrowRight, BookOpenCheck, CreditCard, Mail, ServerCog, UserRoundCheck } from 'lucide-react';
import { appMeta } from '@/config/iphonefastflip';

const topics = [
  {
    icon: UserRoundCheck,
    title: 'Konto i weryfikacja',
    description: 'Problemy z logowaniem, linkiem e-mail, kodem SMS lub synchronizacją profilu.',
  },
  {
    icon: BookOpenCheck,
    title: 'Cenniki i opłacalność',
    description: 'Pomoc z tworzeniem cennika, importem JSON i interpretacją wyniku oferty.',
  },
  {
    icon: CreditCard,
    title: 'Płatności i plan',
    description: 'Stripe Checkout, oczekująca płatność, anulowanie albo portal rozliczeniowy.',
  },
  {
    icon: ServerCog,
    title: 'Testy lokalne',
    description: 'Konfiguracja usług na portach 8080 i 8091, CORS oraz adresy backendu.',
  },
] as const;

const checklist = [
  'Nazwa używanej platformy: web, Android lub Windows',
  'Dokładny ekran i czynność, po której pojawia się problem',
  'Treść komunikatu błędu bez haseł, tokenów i danych karty',
  'Informacja, czy lokalne endpointy /health odpowiadają poprawnie',
] as const;

const Support: React.FC = () => (
  <main className="px-4 pb-24 pt-28 sm:pt-32">
    <div className="mx-auto max-w-6xl">
      <header className="mx-auto mb-14 max-w-3xl text-center">
        <p className="section-eyebrow">Pomoc iPhoneFastFlip</p>
        <h1 className="text-4xl font-black tracking-[-0.04em] text-white sm:text-6xl">Opisz problem. Dołącz dane, które pozwolą go odtworzyć.</h1>
        <p className="section-copy mt-6">Najpierw wybierz obszar, którego dotyczy zgłoszenie. Nie przesyłaj hasła, tokenów Firebase, kluczy Stripe ani pełnych danych płatniczych.</p>
      </header>

      <section className="grid gap-5 md:grid-cols-2">
        {topics.map((topic) => {
          const Icon = topic.icon;
          return (
            <article key={topic.title} className="rounded-[26px] border border-white/[0.08] bg-white/[0.025] p-6 sm:p-7">
              <div className="grid h-12 w-12 place-items-center rounded-2xl bg-blue-500/10 text-blue-300">
                <Icon className="h-6 w-6" />
              </div>
              <h2 className="mt-5 text-xl font-bold text-white">{topic.title}</h2>
              <p className="mt-2 text-sm leading-6 text-slate-400">{topic.description}</p>
            </article>
          );
        })}
      </section>

      <section className="mt-8 grid gap-6 rounded-[30px] border border-blue-400/20 bg-blue-500/[0.07] p-6 sm:p-9 lg:grid-cols-[1fr_0.8fr]">
        <div>
          <p className="section-eyebrow">Co dołączyć</p>
          <h2 className="text-2xl font-black text-white sm:text-3xl">Krótka lista przyspieszająca diagnozę</h2>
          <ul className="mt-6 space-y-3">
            {checklist.map((item) => (
              <li key={item} className="flex gap-3 text-sm leading-6 text-slate-300">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-blue-400" />
                {item}
              </li>
            ))}
          </ul>
        </div>
        <div className="flex flex-col justify-center rounded-2xl border border-white/[0.08] bg-[#0a0f18]/75 p-6">
          <Mail className="h-7 w-7 text-blue-300" />
          <p className="mt-4 text-sm text-slate-500">Kontakt techniczny</p>
          <a href={`mailto:${appMeta.supportEmail}?subject=iPhoneFastFlip%20-%20zgłoszenie`} className="mt-1 break-all text-lg font-bold text-white hover:text-blue-300">
            {appMeta.supportEmail}
          </a>
          <a href={`mailto:${appMeta.supportEmail}?subject=iPhoneFastFlip%20-%20zgłoszenie`} className="button-primary mt-6 w-full">
            Napisz wiadomość <ArrowRight className="h-4 w-4" />
          </a>
        </div>
      </section>

      <section className="mt-6 flex gap-4 rounded-2xl border border-amber-400/20 bg-amber-500/[0.055] p-5 text-sm leading-6 text-amber-100/70">
        <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-300" />
        Wskaźnik opłacalności jest pomocą analityczną. Przed zakupem zawsze samodzielnie sprawdź stan urządzenia, sprzedawcę, blokady, numer seryjny i pełne koszty transakcji.
      </section>
    </div>
  </main>
);

export default Support;
